// ---------------------------------------------------------------------------
// โหมดทดลอง: ฐานข้อมูลจำลองใน localStorage ที่มี API เหมือน fbClient (get/put/patch/update/remove/createOnly/transaction)
// ทำให้โค้ดข้อมูลทั้งแอปเขียนครั้งเดียว ใช้ได้ทั้ง Firebase จริงและโหมดทดลอง
// ---------------------------------------------------------------------------
import { applyQuery } from "./fbClient";
import { MOCK_PREFIX } from "./config";

const KEY = `${MOCK_PREFIX}:db`;
const segs = (p) => String(p || "").split("/").filter(Boolean);
const clone = (v) => (v === undefined ? null : JSON.parse(JSON.stringify(v)));

let tree = null;
const load = () => {
  if (tree) return tree;
  try {
    tree = JSON.parse(localStorage.getItem(KEY) || "{}") || {};
  } catch (e) {
    tree = {};
  }
  return tree;
};
const save = () => {
  try {
    localStorage.setItem(KEY, JSON.stringify(tree));
  } catch (e) {
    /* พื้นที่เต็ม — ข้าม */
  }
};
window.addEventListener?.("storage", (e) => {
  if (e.key === KEY) tree = null;
});

const read = (path) => {
  let node = load();
  for (const s of segs(path)) {
    if (!node || typeof node !== "object") return null;
    node = node[s];
  }
  return node === undefined ? null : node;
};

/** ลบ object ว่างทิ้ง (เหมือน RTDB ที่ไม่เก็บโหนดว่าง) */
const prune = (obj) => {
  if (!obj || typeof obj !== "object") return obj;
  Object.keys(obj).forEach((k) => {
    obj[k] = prune(obj[k]);
    if (obj[k] === null || obj[k] === undefined || (typeof obj[k] === "object" && !Object.keys(obj[k]).length)) delete obj[k];
  });
  return obj;
};

const write = (path, value) => {
  const s = segs(path);
  load();
  if (!s.length) {
    tree = prune(clone(value) || {});
    return;
  }
  let node = tree;
  for (let i = 0; i < s.length - 1; i++) {
    if (!node[s[i]] || typeof node[s[i]] !== "object") node[s[i]] = {};
    node = node[s[i]];
  }
  if (value === null || value === undefined) delete node[s[s.length - 1]];
  else node[s[s.length - 1]] = clone(value);
  prune(tree);
};

const tick = () => new Promise((r) => setTimeout(r, 30));

export const mockFb = {
  async get(path, query) {
    await tick();
    const v = clone(read(path));
    if (!query || !v || typeof v !== "object") return v;
    return Object.fromEntries(applyQuery(v, query));
  },
  async entries(path, query) {
    const d = await mockFb.get(path, query);
    if (!d || typeof d !== "object") return [];
    return applyQuery(d, { orderBy: query && query.orderBy });
  },
  async keys(path) {
    const d = read(path);
    return d && typeof d === "object" ? Object.keys(d) : [];
  },
  async put(path, value) {
    await tick();
    write(path, value);
    save();
  },
  async patch(path, obj) {
    await tick();
    Object.entries(obj || {}).forEach(([k, v]) => write(`${path}/${k}`, v));
    save();
  },
  async remove(path) {
    write(path, null);
    save();
  },
  async update(map) {
    await tick();
    Object.entries(map || {}).forEach(([k, v]) => write(k, v));
    save();
  },
  async createOnly(path, value) {
    if (read(path) !== null) return false;
    write(path, value);
    save();
    return true;
  },
  async transaction(path, fn) {
    const cur = clone(read(path));
    const next = await fn(cur);
    if (next === undefined) return { committed: false, value: cur };
    write(path, next);
    save();
    return { committed: true, value: next };
  },
  /** ล้างข้อมูลทดลองทั้งหมด */
  reset() {
    tree = {};
    save();
  },
};
